<template>
  <transition
    name="fade-in-transition"
    enter-active-class="animated fadeInDown faster"
    leave-active-class="animated fadeOutUp faster">
    <slot />
  </transition>
</template>

<script>
export default {
  name: 'FadeTransition',
}
</script>
